import { render, staticRenderFns } from "./TiersContact.vue?vue&type=template&id=62ec26f8&"
import script from "./TiersContact.vue?vue&type=script&lang=js&"
export * from "./TiersContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports